export default __webpack_public_path__ + "static/media/ISSO CLASS-1 EXAM PATTERN 2026-27.4a246a3e.pdf";